import { FC } from "react";
import { IClassname } from "@/lib/types/classname";

export const SvgGraph: FC<IClassname> = ({ className }) => {
  return (
    <svg
    className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10317_3120)">
        <path
          d="M39 36.3333C39 37.8 37.8 39 36.3333 39H11.6667C10.2 39 9 37.8 9 36.3333V11.6667C9 10.2 10.2 9 11.6667 9H36.3333C37.8 9 39 10.2 39 11.6667V36.3333Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.9332 32.5999C17.9332 33.3999 17.3999 33.9332 16.5999 33.9332H15.2666C14.4666 33.9332 13.9332 33.3999 13.9332 32.5999V28.8665C13.9332 28.0665 14.4666 27.5332 15.2666 27.5332H16.5999C17.3999 27.5332 17.9332 28.0665 17.9332 28.8665V32.5999Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.9333 32.5998C25.9333 33.3998 25.4 33.9332 24.6 33.9332H23.2667C22.4667 33.9332 21.9333 33.3998 21.9333 32.5998V16.8665C21.9333 16.0665 22.4667 15.5332 23.2667 15.5332H24.6C25.4 15.5332 25.9333 16.0665 25.9333 16.8665V32.5998Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.9333 32.6002C33.9333 33.4002 33.4 33.9335 32.6 33.9335H31.2667C30.4667 33.9335 29.9333 33.4002 29.9333 32.6002V23.5335C29.9333 22.7335 30.4667 22.2002 31.2667 22.2002H32.6C33.4 22.2002 33.9333 22.7335 33.9333 23.5335V32.6002Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10317_3120">
          <rect width="32" height="32" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  );
};
